import { render, staticRenderFns } from "./FifthSection.vue?vue&type=template&id=9cd4d900&"
import script from "./FifthSection.vue?vue&type=script&lang=js&"
export * from "./FifthSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports